import { render, staticRenderFns } from "./EditCompanyBankAccounts.vue?vue&type=template&id=9722a3ae&"
import script from "./EditCompanyBankAccounts.vue?vue&type=script&lang=js&"
export * from "./EditCompanyBankAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports